import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = "Athira: The Next Gen compliance management platform";

export const titleSlice = createSlice({
  name: "title",
  initialState,
  reducers: {
    setTitle: (state, action: PayloadAction<string>) => {
      return (state = action.payload);
    },
  },
});

export const { setTitle } = titleSlice.actions;

export default titleSlice.reducer;
